import { actionCreator, Joi, objectSchemaOf } from '../helpers';

export const DISPLAY_OFF = 'SYSTEM/DISPLAY_OFF';

export const displayOffActionSchema = objectSchemaOf<IDisplayOffAction>({
  type: Joi.string().required().valid(DISPLAY_OFF),
});

export interface IDisplayOffAction {
  type: typeof DISPLAY_OFF;
}

export const displayOff = actionCreator({
  type: DISPLAY_OFF,
  schema: displayOffActionSchema,
});
